import { Route, Routes, BrowserRouter } from "react-router-dom";
import About from "./pages/About/About.js";
import Home from "./pages/Home/Home.js";
import EventSmriti from "./pages/Events/Smriti.js";
import EventFinalis from "./pages/Events/Finalis.js";
import EventGraduationTeaParty from "./pages/Events/Graduation Tea Party.js";
import EventInternational from "./pages/Events/International.js";
import EventGraduationBallDance from "./pages/Events/Graduation Ball Dance.js";
import EventSeminar from "./pages/Events/Seminar.js";
import EventGratitudePortal from "./pages/Events/GratitudePortal.js";
import EventLatent48 from "./pages/Events/Latent48.js";

import Initiative from "./pages/Initiative/Initiative.js";
import Calender from "./pages/Calender/Calender.js";
import Error from "./pages/error.js";

const AppRoutes = () => {
  return (
    <BrowserRouter basename={"/sail"}>
      <Routes>
        <Route path="*" element={<Error />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/events-smriti" element={<EventSmriti />} />
        <Route path="/events-finalis-resonare" element={<EventFinalis />} />

        <Route path="/events-graduation-tea-party" element={<EventGraduationTeaParty />} />
        <Route path="/events-international-students-day" element={<EventInternational />} />
        <Route path="/events-graduation-ball-dance" element={<EventGraduationBallDance />} />
        <Route path="/events-seminars" element={<EventSeminar />} />
        <Route path="/events-gratitude-portal" element={<EventGratitudePortal />} />
        <Route path="/events-latent48" element={<EventLatent48 />} />

        <Route path="/initiative" element={<Initiative />} />
        <Route path="/calendar" element={<Calender />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;